import React, { useCallback } from 'react'
import { Backdrop, ModalStyle, buttonStyle } from './style'
import { useTheme } from 'styled-components'
import { BUTTON_LABELS } from 'shared-ui/utils/constants'
const Modal = React.memo(
    ({
        open,
        onClose,
        title,
        children,
        confirmText,
        cancelText,
        onConfirm,
        onCancel,
        okButtonStyle,
        modalStyle={}
    }) => {
        const theme = useTheme()
        const handleClose = useCallback(() => {
            if (onClose) onClose()
        }, [onClose])

        if (!open) return null

        return (
            <Backdrop>
                <ModalStyle style={modalStyle}>
                    {title && (
                        <div
                            className="font-normal mb-[2vh] text-[24px] leading-[20px]"
                            style={{ color: theme.app.text }}
                        >
                            {title}
                        </div>
                    )}
                    <div
                        className="mb-[2vh] text-sm font-normal"
                        style={{ color: theme.app.text }}
                    >
                        {children}
                    </div>
                    <div className="flex gap-3 justify-end">
                        {onCancel && (
                            <button
                                className="mt-6 mr-5 bg-none text-[#00bfff] border-none cursor-pointer"
                                onClick={onCancel}
                            >
                                {cancelText || BUTTON_LABELS?.cancel}
                            </button>
                        )}
                        {onConfirm ? (
                            <button
                                className="mt-6 mr-3 bg-none text-[#00bfff] border-none cursor-pointer"
                                onClick={onConfirm}
                            >
                                {confirmText || BUTTON_LABELS?.OK}
                            </button>
                        ) : (
                            <button
                                style={
                                    okButtonStyle
                                        ? { ...buttonStyle, ...okButtonStyle }
                                        : buttonStyle
                                }
                                onClick={handleClose}
                            >
                                {BUTTON_LABELS?.OK}
                            </button>
                        )}
                    </div>
                </ModalStyle>
            </Backdrop>
        )
    }
)

export default Modal
